import React from 'react';
import { fmt } from '../kuroco/fmt';

const show = (unit, v) => (v != null && v !== '—' ? fmt(unit, v) : '—');

/** One 実績 / 目標（達成率） row. */
function TargetRow({ icon, label, unit, actual, target, pct }) {
  return (
    <div className="dcard-row">
      <span className="dcard-metric">
        {icon} {label}
      </span>
      <span className="dcard-val">
        {show(unit, actual)}{' '}
        {target != null && (
          <span className="sub">
            / {show(unit, target)}
            {pct != null && pct !== '—' ? `（${pct}%）` : ''}
          </span>
        )}
      </span>
    </div>
  );
}

/**
 * 当月 vs 目標 — shared by static AiReview and live AiHome so the two can't drift.
 * Values come from monthSnap + focus defs; missing goals render as 「—」.
 * Rows: 売上 (KGI) → 追加KGI (when set) → one row per 注力 the user set (1–3).
 */
export default function MonthVsTargetCard({ data }) {
  const s = data.monthSnap;

  return (
    <div className="dcard">
      <div className="dcard-label">{s.label} 当月 vs 目標</div>
      <TargetRow icon="💰" label="売上" unit="currency" actual={s.salesActual} target={s.salesTarget} pct={s.salesPct} />
      {s.subKgi && <TargetRow {...s.subKgi} />}
      {(s.focusRows || []).map((r) => (
        <TargetRow {...r} key={r.slot} />
      ))}
      <div className="dcard-row">
        {/* Runway to the goal date. Falls back to the month tail only when no goal is set. */}
        <span className="dcard-metric">
          {data.period.daysToGoal != null
            ? `⏳ 目標まで残り${data.period.daysToGoal}日`
            : data.period.isCurrentMonth
              ? `⏳ 残り${data.period.daysLeft}日`
              : '✓ 集計終了'}
        </span>
        <span className="dcard-val">
          {s.yenDaily != null ? (
            <>
              1日 約<strong>¥{s.yenDaily},000</strong> 必要
            </>
          ) : (
            '—'
          )}
        </span>
      </div>
    </div>
  );
}
